<template>
  <div class="login_body">
    <div class="login_body_left">
      <div class="login_body_logo">
        <img :src="loginicon" alt />
      </div>
      <div class="login_body_left_title">蛋鸡管家</div>
      <div class="login_body_left_name">全国蛋鸡产业信息化服务平台</div>
      <div
        class="login_body_left_content"
      >蛋鸡管家APP是一款实用型全国蛋鸡产业信息化平台，它不仅为蛋鸡养殖户免费提供国家最新政策、行业新闻等热点资讯以外，更有蛋商加盟为养殖户们提供精确的鸡蛋报价，玉米、豆粕等原料价格，实时更新的价格曲线让您对当前行情了如指掌。</div>
    </div>

    <div class="login_body_right">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="账号登录" name="first"></el-tab-pane>
        <el-tab-pane label="手机快捷登录" name="second"></el-tab-pane>
      </el-tabs>

      <div class="loginIn_body" v-if="activeName == 'first'">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <el-form-item prop="user_name" class="user_name">
            <el-input v-model="ruleForm.user_name" name="user_name" placeholder="请输入用户名/手机" />
          </el-form-item>
          <el-form-item prop="user_pwd" class="user_pwd">
            <el-input
              v-model="ruleForm.user_pwd"
              type="password"
              name="user_pwd"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item  prop="code" class="code">
                <el-input v-model="ruleForm.code"  placeholder="请输入校验码"></el-input>
          </el-form-item>-->
          <div class="loginIn_body_1">
            <el-checkbox-group v-model="ruleForm.remember_pwd" prop="remember_pwd">
              <el-checkbox label="下次自动登录" name="remember_pwd"></el-checkbox>
            </el-checkbox-group>
            <router-link tag="a" class="forget_pwd" :to="'/Forget'">忘记密码</router-link>
            <router-link tag="a" class="regist" :to="'/Register'">立即注册</router-link>
          </div>
          <el-button class="loginIn_body_button" @click="submitForm('ruleForm')">登录</el-button>
        </el-form>
      </div>

      <div class="loginIn_body" v-if="activeName == 'second'">
        <el-form :model="ruleForm_s" :rules="rules_s" ref="ruleForm_s">
          <el-form-item prop="phone" class="phone">
            <el-input v-model="ruleForm_s.phone" name="phone" placeholder="请输入手机号" />
          </el-form-item>
          <el-form-item prop="phone_code" class="phone_code">
            <el-input v-model="ruleForm_s.phone_code" placeholder="请输入短信验证码"></el-input>
          </el-form-item>
          <div class="send_button" :class="{'send_button_stop':!stop}" @click="getCode">{{btn_msg}}</div>
          <div class="loginIn_body_1">
            <el-checkbox-group v-model="ruleForm_s.remember_pwd" prop="remember_pwd">
              <el-checkbox label="下次自动登录" name="remember_pwd"></el-checkbox>
            </el-checkbox-group>
            <router-link tag="a" class="regist1" :to="'/Register'">立即注册</router-link>
          </div>
          <el-button class="loginIn_body_button" @click="submitForm_s('ruleForm_s')">登录</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  userLogin,
  webSocketCallBack,
  identifyingCodes,
  pc_mobile_login
} from "../api/api";

export default {
  name: "Login",
  inject: ['reload'],
  data() {
    return {
      loginicon: "./static/img/loginicon.png",
      activeName: "first",
      path: "ws://breed.danjiguanjia.com:8282/",
      btn_msg: "发送验证码",
      time: 60,
      stop: true,
      interval: "",
      send_button_stop: false,
      ruleForm: {
        user_name: "",
        user_pwd: "",
        code: "",
        remember_pwd: true
      },
      rules: {
        user_name: [{ required: true, message: "用户名不能为空" }]
      },
      ruleForm_s: {
        phone: "",
        phone_code: "",
        remember_pwd: true
      },
      rules_s: {
        phone: [
          { required: true, message: "手机号不能为空" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ],
        phone_code: [{ required: true, message: "验证码不能为空" }]
      },
      rules_ss: {
        phone: [
          { required: true, message: "手机号不能为空" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.commit("settab", "");
    if (localStorage.getItem("ticket")) {
      this.$router.push("/");
      return false;
    }
  },
  methods: {
    handleClick(tab, event) {
      this.activeName = tab.name;
      console.log(this.activeName);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          userLogin({
            user_name: this.ruleForm.user_name,
            user_pwd: this.ruleForm.user_pwd,
            decive: "PC"
          }).then(res => {
            console.log(res);
            if (res.retcode == 2000) {
              this.$message({
                message: "登录成功",
                type: "success"
              });
              if(res.data.data.check == 1){
                setTimeout(() => {
                  this.$message.error("初始密码，请修改密码");
                  this.$router.push("/ChangePassword/"+this.ruleForm.user_pwd)
                }, 2000);
                return false;
              }else{
                localStorage.setItem("ticket", res.data.data.ticket);
                localStorage.setItem("real_name", res.data.info.nname);
                localStorage.setItem("cover", res.data.info.cover);
                localStorage.setItem("breed", res.data.data.breed);
              }
              setTimeout(() => {
                if(localStorage.getItem('local') == null){
                  localStorage.setItem("local", "/p/System");
                }
                this.reload();
                this.$router.push(localStorage.getItem('local'));
              }, 2000);
            } else {
              this.$message.error(res.msg);
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    submitForm_s(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          pc_mobile_login({
            user_name: this.ruleForm_s.phone,
            code: this.ruleForm_s.phone_code,
            decive: "PC"
          }).then(res => {
            console.log(res);
            if (res.retcode == 2000) {
              localStorage.setItem("ticket", res.data.data.ticket);
              localStorage.setItem("real_name", res.data.info.nname);
              localStorage.setItem("cover", res.data.info.cover);
              localStorage.setItem("breed", res.data.data.breed);
              this.$message({
                message: "登录成功",
                type: "success"
              });
              setTimeout(() => {
                if(localStorage.getItem('local') == null){
                  localStorage.setItem("local", "/p/System");
                }
                this.reload();
                this.$router.push(localStorage.getItem('local'));
              }, 2000);
            } else {
              this.$message.error(res.msg);
              return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    //获取验证码
    getCode() {
      if (this.ruleForm_s.phone != "") {
        if (!this.stop) return;
        identifyingCodes({
          phone: this.ruleForm_s.phone
        })
          .then(rs => {
            if (rs.retcode == 2000) {
              clearInterval(this.interval);
              this.interval = setInterval(this.timer, 1000);
              this.time = 60;
            } else if (rs.retcode == 4001) {
              this.$message.error("60s内不能重复发送!");
            } else if (rs.retcode == 4002) {
              this.$message.error("发送失败!");
            } else {
              this.$message.error("该用户没有注册!");
            }
          })
          .catch(function(err) {
            this.$message.error("网络错误!");
          });
      } else {
        this.$message.error("请先填写手机号、密码!");
      }
    },
    //设置定时器 当返回值为2000的时候调用,替换原来的获取验证码
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btn_msg = this.time > 0 ? this.time + "秒后获取" : "重新获取";
        this.stop = false;
      } else if (this.time == 0) {
        this.stop = true;
        this.send_button_stop = true;
        clearInterval(this.interval);
      }
    }
  }
};
</script>

<style>
.login_body {
  position: relative;
  width: 100%;
  height: 936px;
  margin-top: 30px;
  background: url("~@/assets/background.png") no-repeat center center;
  background-size: 100% 100%;
}
.login_body_left {
  position: absolute;
  left: 221px;
  top: 284px;
}
.login_body_logo {
  width: 427px;
  height: 208px;
}
.login_body_logo img {
  width: 100%;
  height: 100%;
}
.login_body_left_title {
  font-size: 26px;
  margin-top: 73px;
  color: #9cc637;
}
.login_body_left_name {
  font-size: 22px;
  margin-top: 20px;
  color: #e4e4e3;
}
.login_body_left_content {
  margin-top: 30px;
  font-size: 16px;
  width: 600px;
  height: 77px;
  color: #efefef;
}
.login_body_right {
  position: absolute;
  top: 158px;
  right: 220px;
  background: #ffffff;
  width: 550px;
  /* height: 500px; */
  border-radius: 10px;
}
.login_body_right .el-tabs__item {
  font-size: 20px;
  height: 77px;
  margin-top: 25px;
}
.login_body_right .el-tabs__item.is-active {
  color: #56b234;
}
.login_body_right #tab-first {
  margin-left: 168px;
}
.login_body_right .el-tabs__active-bar {
  background-color: #56b234;
  margin-left: 168px;
}
.login_body_right .el-tabs__item:hover {
  color: #56b234 !important;
}
.login_body_right .el-tabs__nav-wrap .el-tabs__nav-scroll .el-tabs__nav {
  width: 100%;
  height: 77px;
  line-height: 77px;
}

.login_body_right .el-tabs__nav-wrap {
  height: 77px;
  width: 100%;
}
.login_body_right .el-tabs__header {
  height: 77px;
  width: 100%;
}
.login_body_right .loginIn_body {
  width: 400px;
  margin: 0 auto;
}
.user_name input {
  height: 46px;
  margin-top: 25px;
  background: url("~@/assets/user.png") no-repeat;
  padding-left: 60px;
  background-size: 18px 24px;
  background-position-x: 17px;
  background-position-y: 9px;
}
.user_pwd input {
  height: 46px;
  margin-top: 15px;
  background: url("~@/assets/key.png") no-repeat;
  padding-left: 60px;
  background-size: 18px 24px;
  background-position-x: 17px;
  background-position-y: 9px;
}
.code input {
  height: 46px;
  margin-top: 15px;
  background: url("~@/assets/suo.png") no-repeat;
  padding-left: 60px;
  background-size: 18px 24px;
  background-position-x: 17px;
  background-position-y: 9px;
}
.loginIn_body_button {
  width: 400px;
  height: 44px;
}
.loginIn_body .el-button {
  margin-top: 30px;
  background: #56b234;
  font-size: 20px;
  color: #ffffff;
  margin-bottom: 61px;
}

.checkbox__label {
  font-size: 16px;
  color: #060001;
}
.loginIn_body_1 {
  display: flex;
  height: 16px;
  margin-top: 35px;
  font-size: 16px;
  color: #060001;
}
.loginIn_body_1 a {
  color: #060001;
}
.forget_pwd {
  color: #060001;
  margin-left: 110px;
}
.regist {
  color: #060001;
  margin-left: 26px;
}
.regist1 {
  color: #060001;
  margin-left: 204px;
}
.loginIn_body_1 .el-checkbox__input {
  color: #000000;
}
.loginIn_body_1 .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #060001;
  border-color: #060001;
}
.loginIn_body_1 .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #060001;
}
.phone input {
  height: 46px;
  margin-top: 25px;
  background: url("~@/assets/phone.png") no-repeat;
  padding-left: 60px;
  background-size: 18px 24px;
  background-position-x: 17px;
  background-position-y: 9px;
}
.phone_code input {
  height: 46px;
  width: 290px;
  margin-top: 15px;
  background: url("~@/assets/suo.png") no-repeat;
  padding-left: 60px;
  background-size: 18px 24px;
  background-position-x: 17px;
  background-position-y: 9px;
}
.phone_code .el-form-item__content {
  width: 150px;
}
.send_button {
  width: 110px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  background: #56b234;
  font-size: 18px;
  color: #ffffff;
  float: right;
  margin-top: -68px;
  cursor: pointer;
}
.send_button_stop {
  background: #b1d3a9;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue